<template>
	<div class="slide-one">
		<div class="filter-bg" />
		<div class="wrap-img">
			<img class="phone-img" src="../assets/img/2.png" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'Home',
}
</script>

<style lang="scss" scoped>
.slide-one {
	/* 设置容器尺寸，否则可能看不到背景图 */
	width: 100%;
	height: 110vh; /* 占满整个视口高度 */
	background: url(../assets/img/2.png) no-repeat center;
	background-size: cover;

	.wrap-img {
		display: none;
	}
}

@media (max-width: 768px) {
	.slide-one {
		background: unset;
		// background-color: #bfe0f8;
		height: calc(100vh - 274px); /* 占满整个视口高度 */
		// filter: blur(10px);
		position: relative;
		.filter-bg {
			width: 100%;
			height: 100%;
			position: absolute;
			background: url(../assets/img/blur_bg.png) no-repeat center;
			background-size: cover;
			filter: blur(5px);
		}
		.wrap-img {
			display: block;
			width: 100%;
			position: absolute;
			top: 30%;
			.phone-img {
				width: 100%;
			}
		}
	}
}
</style>
